import supper from '../images/supper.jpg'

css .weddings-page
	min-height:100vh
	d:flex
	fld:column
	.shape-header
		h:300px
	.weddings
		flg: 1

tag weddings-page
	<self.weddings-page>
		<shape-header title="Weddings" image=supper>
		<text-block.weddings title="Weddings">
			<p[mb:1em]>
				"Located in downtown San Antonio near hotels, attractions and reception venues, our beautiful sanctuary seats up to 300 guests. For a more intimate wedding our newly renovated chapel seats 50 guests comfortably."
		<footer-section>